module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular.448c34a56d699c29117adc64c43affeb.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-css-only/fonts/glyphicons-halflings-regular.woff2
 ** module id = 448
 ** module chunks = 1
 **/